export { useAdobeDataLayer } from "./use-adobe-data-layer.hook";
